import { decimalToPercentage, numberToText } from "./transformators";

// Ignore Enter Key, showCalculator on Enter, and Arrow Navigation
export const ignoreEnter = (e, setShowcalculator, showcalculator) => {
  if (e.key === "Enter") {
    e.preventDefault();
    const calculatorMap = {
      insurancecost: "insurance",
      importcustomsfee: "importcustomsfee",
      inboundcost: "inboundcost",
      outboundcost: "outboundcost",
      freightpmt: "oceanfreight",
    };
    if (calculatorMap[e.target.name]) {
      setShowcalculator(calculatorMap[e.target.name]);
    }
    if (showcalculator) {
      setShowcalculator("");
    }
  } else if (e.key === "ArrowDown" || e.key === "ArrowUp") {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    const nextElement = e.key === "ArrowDown" ? form.elements[index + 1] : form.elements[index - 1];
    if (nextElement) {
      nextElement.focus();
    }
  }
};

// Figure input change
export const handleFigureChange = (e, figuretype, setUSposition, setUSpositionData, setEditingField, dec = 2) => {
  setEditingField(true);
  if (figuretype === "currency") {
    const isUScurrency = RegExp("^[$]{0,1}[0-9]*[.]{0,1}[0-9%]*$");
    if (isUScurrency.test(e.target.value) || e.target.value === "") {
      setUSposition((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
      setUSpositionData((prev) => ({
        ...prev,
        [e.target.name]: Number(Number(e.target.value.replace(",", "").replace("$", "")).toFixed(dec)),
      }));
    }
  }
  if (figuretype === "decimal") {
    const isdecimalnumber = RegExp("^[0-9]*[.]{0,1}[0-9]*$");
    if (isdecimalnumber.test(e.target.value) || e.target.value === "") {
      setUSposition((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
      setUSpositionData((prev) => ({
        ...prev,
        [e.target.name]: Number(Number(e.target.value).toFixed(dec)),
      }));
    }
  }
  if (figuretype === "percent") {
    const isdecimalnumber = RegExp("^[0-9]*[.]{0,1}[0-9%]*$");
    if (isdecimalnumber.test(e.target.value) || e.target.value === "") {
      if (e.target.value.toString().includes("%")) {
        setUSpositionData((prev) => ({
          ...prev,
          [e.target.name]: Number(e.target.value.replace("%", "")).toFixed(dec) / 100,
        }));
        setUSposition((prev) => ({
          ...prev,
          [e.target.name]: e.target.value.replace("%", ""),
        }));
      } else {
        setUSpositionData((prev) => ({
          ...prev,
          [e.target.name]: Number(e.target.value).toFixed(dec) / 100,
        }));
        setUSposition((prev) => ({
          ...prev,
          [e.target.name]: e.target.value,
        }));
      }
    }
  }
  if (figuretype === "integer") {
    const isInteger = RegExp("^[0-9]+$");
    if (isInteger.test(e.target.value) || e.target.value === "") {
      setUSposition((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
      setUSpositionData((prev) => ({
        ...prev,
        [e.target.name]: Number(e.target.value),
      }));
    }
  }
  if (figuretype === "text") {
    setUSposition((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
    setUSpositionData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  }
};

//Figure Input Blur
export const handleFigureBlur = (
  e,
  figuretype,
  setUSposition,
  positionEdits,
  editID,
  setEditID,
  editingField,
  setEditingField,
  undoList,
  dec = 2
) => {
  // console.log(editID);
  if (figuretype === "currency") {
    setUSposition((prev) => ({
      ...prev,
      [e.target.name]:
        "$" +
        Number(e.target.value.replace(",", "").replace("$", ""))
          .toFixed(dec)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
    }));
    if (editingField) {
      positionEdits.current.push({
        editID: editID,
        name: e.target.name,
        value: Number(e.target.value.replace("$", "")).toFixed(dec),
        num: Number(Number(e.target.value.replace("$", "")).toFixed(dec)),
        figuretype: "currency",
      });
      setEditID((prev) => prev + 1);
      setEditingField(false);
      undoList.current = [];
      // console.log(positionEdits.current);
      // console.log(undoList.current);
    }
  }
  if (figuretype === "decimal") {
    setUSposition((prev) => ({
      ...prev,
      [e.target.name]: Number(e.target.value.replace("$", "")).toFixed(dec),
    }));
    // console.log(editingField);
    if (editingField) {
      positionEdits.current.push({
        editID: editID,
        name: e.target.name,
        value: Number(e.target.value.replace("$", "")).toFixed(dec),
        num: Number(Number(e.target.value).toFixed(dec)),
        figuretype: "decimal",
      });
      setEditID((prev) => prev + 1);
      setEditingField(false);
      undoList.current = [];
      // console.log(positionEdits.current);
      // console.log(undoList.current);
    }
  }
  if (figuretype === "percent") {
    setUSposition((prev) => ({
      ...prev,
      [e.target.name]: Number(e.target.value.replace("%", "")).toFixed(dec) + "%",
    }));
    if (editingField) {
      positionEdits.current.push({
        editID: editID,
        name: e.target.name,
        value: Number(e.target.value.replace("%", "")).toFixed(dec) + "%",
        num: Number(e.target.value.replace("%", "")).toFixed(dec) / 100,
        figuretype: "percent",
      });
      setEditID((prev) => prev + 1);
      setEditingField(false);
      undoList.current = [];
      // console.log(positionEdits.current);
      // console.log(undoList.current);
    }
  }
  if (figuretype === "integer") {
    console.log(Number(Number(e.target.value.replace("$", "")).toFixed(0)));
    setUSposition((prev) => ({
      ...prev,
      [e.target.name]: e.target.value === "" ? "" : Number(Number(e.target.value.replace("$", "")).toFixed(0)),
    }));
    if (editingField) {
      positionEdits.current.push({
        editID: editID,
        name: e.target.name,
        value: Number(Number(e.target.value.replace("$", "")).toFixed(0)),
        num: Number(e.target.value),
        figuretype: "integer",
      });
      setEditID((prev) => prev + 1);
      setEditingField(false);
      undoList.current = [];
    }
  }
  if (figuretype === "text") {
    setUSposition((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
    if (editingField) {
      positionEdits.current.push({
        editID: editID,
        name: e.target.name,
        value: e.target.value,
        num: e.target.value,
        figuretype: "text",
      });
      setEditID((prev) => prev + 1);
      setEditingField(false);
      undoList.current = [];
    }
  }
};
// Percentage Change
export const handlePercentageChange = (e, setUSposition, setUSpositionData, dec = 2) => {
  const isdecimalnumber = RegExp("^[0-9]*[.]{0,1}[0-9%]*$");
  if (isdecimalnumber.test(e.target.value) || e.target.value === "") {
    if (e.target.value.toString().includes("%")) {
      setUSpositionData((prev) => ({
        ...prev,
        [e.target.name]: Number(e.target.value.replace("%", "")).toFixed(dec) / 100,
      }));
      setUSposition((prev) => ({
        ...prev,
        [e.target.name]: e.target.value.replace("%", ""),
      }));
    } else {
      setUSpositionData((prev) => ({
        ...prev,
        [e.target.name]: Number(e.target.value).toFixed(dec) / 100,
      }));
      setUSposition((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    }
  }
};
// Percentage Blur
export const handlePercentageBlur = (e, setUSposition, dec = 2) => {
  setUSposition((prev) => ({
    ...prev,
    [e.target.name]: Number(e.target.value.replace("%", "")).toFixed(dec) + "%",
  }));
};

// Handle paymentterm input changes
export const handlePaytermInputChange = (
  ind,
  el1,
  e,
  paymentterm,
  paymenttermData,
  setPaymentterm,
  setPaymenttermData,
  setEditingField
) => {
  setEditingField(true);
  const temp = paymentterm[ind];
  const tempdata = paymenttermData[ind];
  let value;
  let num;
  if (el1 === "portion") {
    const isdecimalnumber = RegExp("^[0-9]*[.]{0,1}[0-9%]*$");
    if (isdecimalnumber.test(e.target.value) || e.target.value === "") {
      if (e.target.value.toString().includes("%")) {
        value = e.target.value.replace("%", "");
        num = Number(e.target.value.replace("%", "")).toFixed(2);
      } else {
        value = e.target.value;
        num = Number(e.target.value).toFixed(2) / 100;
      }
    }
  } else if (el1 === "termdays") {
    const isInteger = RegExp("^[0-9]+$");
    if (isInteger.test(e.target.value) || e.target.value === "") {
      value = e.target.value;
      num = Number(e.target.value);
    }
  }
  setPaymentterm((prev) => prev.map((item) => (item.row === temp.row ? { ...item, [e.target.name]: value } : item)));
  setPaymenttermData((prev) =>
    prev.map((item) => (item.row === tempdata.row ? { ...item, [e.target.name]: num } : item))
  );
  // setPaymentterm((prev) => [...prev.slice(0, ind), temp, ...prev.slice(ind + 1, prev.length)]);
  // setPaymenttermData((prev) => [...prev.slice(0, ind), tempdata, ...prev.slice(ind + 1, prev.length)]);
};

// Handle Payment Term Input Blur
export const handlePaytermInputBlur = (
  ind,
  el1,
  e,
  paymentterm,
  setPaymentterm,
  positionEdits,
  editingField,
  editID,
  setEditID,
  setEditingField,
  undoList,
  paymenttermData
) => {
  const temp = paymentterm[ind];
  const tempData = paymenttermData[ind];
  let value;
  let num;
  if (el1 === "portion") {
    // temp[e.target.name] = Number(e.target.value.replace("%", "")).toFixed(2) + "%";
    // tempData[e.target.name] = Number(e.target.value.replace("%", "")).toFixed(2) / 100;
    value = Number(e.target.value.replace("%", "")).toFixed(2) + "%";
    num = Number(e.target.value.replace("%", "")).toFixed(2) / 100;
  }
  if (el1 === "termdays") {
    value = e.target.value;
    num = Number(e.target.value);
  }
  if (editingField) {
    positionEdits.current.push({
      editID: editID,
      // name: e.target.id,
      name: e.target.name + (temp.posPaytermID || temp.row),
      value: value,
      num: num,
      figuretype: el1,
      ind: ind,
      temp: temp,
      tempData: tempData,
      row: temp.posPaytermID || temp.row,
    });
    // console.log(positionEdits.current);
    setEditID((prev) => prev + 1);
    setEditingField(false);
    undoList.current = [];
  }
  // console.log(positionEdits.current);
  setPaymentterm((prev) => prev.map((item) => (item.row === temp.row ? { ...item, [e.target.name]: value } : item)));
};

// Handle PayType Selection
export const SelectPayType = (
  item,
  ind,
  paymentterm,
  setPaymentterm,
  paymenttermData,
  setPaymenttermData,
  editingField,
  positionEdits,
  editID,
  el1,
  setEditID,
  setEditingField,
  undoList
) => {
  // console.log("before", positionEdits.current);
  const temp = paymentterm[ind];
  const tempData = paymenttermData[ind];
  temp["payType"] = item.payType;
  tempData["payTypeID"] = item.payTypeID;
  setPaymentterm((prev) => prev.map((item) => (item.row === temp.row ? { ...item, ["payType"]: item.payType } : item)));
  setPaymenttermData((prev) =>
    prev.map((item) => (item.row === tempData.row ? { ...item, ["payTypeID"]: item.payTypeID } : item))
  );
  // if (editingField) {
  positionEdits.current.push({
    editID: editID,
    name: el1 + (temp.posPaytermID || temp.row),
    value: item.payType,
    num: item.payTypeID,
    figuretype: "payType",
    ind: ind,
    temp: temp,
    tempData: tempData,
    row: temp.posPaytermID || temp.row,
  });
  // console.log("after", positionEdits.current);
  setEditID((prev) => prev + 1);
  // setEditingField(false);
  undoList.current = [];
  // }
};

// Add Edits
export const addEdits = (item, positionEdits, editID, setEditID, ...fieldNames) => {
  // Add edits to positionEdits ref
  fieldNames.forEach((field, i) => {
    if (item[field] !== undefined) {
      positionEdits.current.push({
        editID: editID,
        nameID: field + "ID",
        valueID: item[field + "ID"],
        name: field,
        value: item[field],
      });
    }
    setEditID((prev) => prev + 1);
  });
  // console.log(item);
  // console.log(positionEdits.current);

  // enforce max length = 50
  // if (positionEdits.current.length > 50) {
  //   positionEdits.current = positionEdits.current.slice(-50);
  // }
};

// ProdSupplier
export const handleProductSelect = (
  item,
  setUSposition,
  setUSpositionData,
  positionEdits,
  addEdits,
  editID,
  setEditID,
  undoList
) => {
  setUSposition((prev) => ({
    ...prev,
    ["product"]: item.product,
    ["supplier"]: item.supplier,
  }));
  setUSpositionData((prev) => ({
    ...prev,
    ["productID"]: item.productID,
    ["supplierID"]: item.supplierID,
  }));
  // if (positiontoedit) {
  addEdits(item, positionEdits, editID, setEditID, "product", "supplier");
  undoList.current = [];

  // }
  // console.log(positionEdits.current);
};

// handle input Select
export const handleInputSelect = (
  item,
  positionEdits,
  editID,
  setEditID,
  setUSposition,
  setUSpositionData,
  addEdits,
  undoList,
  originname,
  destinationname,
  globalparams
) => {
  setUSposition((prev) => ({
    ...prev,
    [destinationname]: item[originname],
  }));
  setUSpositionData((prev) => ({
    ...prev,
    [destinationname + "ID"]: item[originname + "ID"],
  }));

  addEdits(item, positionEdits, editID, setEditID, destinationname);
  const insuranceRates = {
    DAP: { rate: globalparams?.DAPInsuranceRate, factor: globalparams?.CIPInsuranceFactor },
    CIP: { rate: globalparams?.CIPInsuranceRate, factor: globalparams?.CIPInsuranceFactor },
    CIF: { rate: globalparams?.CIPInsuranceRate, factor: globalparams?.CIPInsuranceFactor },
    CPT: { rate: globalparams?.CPTInsuranceRate, factor: globalparams?.CIPInsuranceFactor },
    CFR: { rate: globalparams?.CPTInsuranceRate, factor: globalparams?.CIPInsuranceFactor },
  };
  if (destinationname === "sincoterm") {
    console.log(globalparams);
    const { rate, factor } = insuranceRates[item["sincoterm"]] || { rate: 0, factor: 0 };
    positionEdits.current.push({
      name: "insurancerate",
      value: decimalToPercentage(rate),
      num: rate,
      editID: editID,
    });

    positionEdits.current.push({
      name: "insurancefactor",
      value: numberToText(factor),
      num: factor,
      editID: editID,
    });
  }
  undoList.current = [];
};

export const handleDelPayRow = (
  paymentterm,
  paymenttermData,
  setPaymentterm,
  setPaymenttermData,
  setReloadpayterms,
  ind,
  positionEdits,
  editID,
  setEditID,
  undoList,
  payrow,
  loadedPayterm,
  loadedPaytermData
) => {
  // let temppay = structuredClone(paymentterm);
  // let temppaydata = structuredClone(paymenttermData);

  let temp = structuredClone(paymentterm[ind]);
  let tempData = structuredClone(paymenttermData[ind]);

  if (paymentterm.length > 1) {
    setPaymentterm((prev) => [...prev.slice(0, ind), ...prev.slice(ind + 1, prev.length)]);
    setPaymenttermData((prev) => [...prev.slice(0, ind), ...prev.slice(ind + 1, prev.length)]);
    // loadedPayterm.current = loadedPayterm.current.filter((item) => item.row !== temp.row);
    // loadedPaytermData.current = loadedPaytermData.current.filter((item) => item.row !== temp.row);
    // setReloadpayterms((prev) => !prev);
  }

  positionEdits.current.push({
    editID: editID,
    figuretype: "delpayrow",
    ind: ind,
    temp: temp,
    tempData: tempData,
    name: "delrow" + temp.row,
    // temppay: temppay,
    // temppaydata: temppaydata,
    row: temp.row,
  });
  setEditID((prev) => prev + 1);
  undoList.current = [];
  // console.log(positionEdits.current);
};

export const handleAddPayRow = (
  setPaymentterm,
  setPaymenttermData,
  payrow,
  positionEdits,
  editID,
  setEditID,
  undoList,
  loadedPayterm,
  loadedPaytermData,
  positiontoedit
) => {
  payrow.current = payrow.current + 1;
  // console.log(payrow.current);
  setPaymentterm((prev) => [
    ...prev,
    {
      row: payrow.current,
      portion: "0.00%",
      payType: "CAD",
      termdays: "10",
      type: "new",
      positionID: positiontoedit || null,
    },
  ]);
  setPaymenttermData((prev) => [
    ...prev,
    { row: payrow.current, portion: 0, payTypeID: 1, termdays: 10, type: "new", positionID: positiontoedit || null },
  ]);
  loadedPayterm.current.push({
    row: payrow.current,
    portion: "0.00%",
    payType: "CAD",
    termdays: "10",
    type: "new",
    positionID: positiontoedit || null,
  });
  loadedPaytermData.current.push({
    row: payrow.current,
    portion: 0,
    payTypeID: 1,
    termdays: 10,
    type: "new",
    positionID: positiontoedit || null,
  });
  positionEdits.current.push({
    editID: editID,
    name: "addrow" + payrow.current,
    figuretype: "addpayrow",
    row: payrow.current,
    positionID: positiontoedit || null,
  });
  setEditID((prev) => prev + 1);
  undoList.current = [];
  // console.log(positionEdits.current);
};
